/**
 * Normalizes a full name to a consistent identifier format.
 * Used for creating internal email identifiers for authentication.
 * 
 * @example
 * normalizeNameToId("Roberto Carrillo") // "roberto_carrillo"
 * normalizeNameToId("María José García") // "maria_jose_garcia"
 * normalizeNameToId("  Juan   Pérez  ") // "juan_perez"
 */
export function normalizeNameToId(name: string): string {
  return name
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // Remove accents
    .replace(/[^a-z0-9\s]/g, '')     // Only letters, numbers, spaces
    .trim()
    .replace(/\s+/g, '_');           // Spaces to underscores
}
